import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { LoginComponent } from './seguridad/login/login.component';
import { WhItemInventarioComponent } from './erp/logistica/whItemmast/vista/whitemmast-inventario.component';
import { PedidosSeguimiento } from './erp/comercial/seguimiento/vista/pedidos-seguimiento.component';
import { CodCotizacionListado } from './erp/comercial/cotizacion/vista/cotizacion-listado.component';
import { ShellComponent } from './view/shell/shell.component';
import { DashboardDemoComponent } from './view/shell/app-dashboard/dashboarddemo.component';
import { PedidoListadoComponent } from './erp/comercial/pedido/vista/pedido-listado.component';
import { CoDocumentoCobrarlistadoComponent } from './erp/comercial/codocumento/vista/documento_por_cobrar_listado/codocumentocobrar-listado.component';
import { ClienteListadoComponent } from './erp/core/personamast/vista/listado/cliente-listado.component';
import { WhItemMastComponent } from './erp/logistica/whItemmast/vista/whItemmast-listado.component';
import { WhItemDetalleComponent } from './erp/logistica/whItemmast/vista/whitemmast-detalle.component';
import { LetralistadoComponent } from './erp/comercial/codocumento/vista/letra_listado/letra-listado.component';
import { LineaCreditoComponent } from './erp/core/clientemast/vista/linea-credito/linea-credito.component';
import { GenerarPedidoListadoComponent } from './erp/comercial/cotizacion/vista/generarpedido/generarpedido-listado.component';
import { CoCobranzaListado } from './erp/comercial/cocobranza/vista/cobranza-listado.component';
import { PedidoMantenimientoNuevoComponent } from './erp/comercial/pedido/vista/pedido-mantenimiento-nuevo.component';
import { CoCotizacionMantenimientoNuevoComponent } from './erp/comercial/cotizacion/vista/cocotizacion-mantenimiento-nuevo.component';
import { CoDocumentoCobrarNuevolistadoComponent } from './erp/comercial/codocumento/vista/documento_por_cobrar_listado/codocumentocobrar-nuevo-listado.component';

export const routes: Routes = [

    { path: '', component: LoginComponent },
    { path: 'login', component: LoginComponent },
    {
        path: 'royal', component: ShellComponent,
        children: [
            { path: '', component: DashboardDemoComponent },
            { path: 'home', component: DashboardDemoComponent },
            { path: 'pedido-listado', component: PedidoListadoComponent },

            // { path: 'codocumentocobrar-listado', component: CoDocumentoCobrarlistadoComponent },
            // { path: 'codocumentocobrar-listado/:cliente', component: CoDocumentoCobrarlistadoComponent },
            // { path: 'codocumentocobrar-listado/:cliente/:accion/:filtro', component: CoDocumentoCobrarlistadoComponent },
            //{ path: 'codocumentocobrar-listado/:accion/:bean', component: CoDocumentoCobrarlistadoComponent },

            { path: 'codocumentocobrar-listado', component: CoDocumentoCobrarNuevolistadoComponent },
            { path: 'codocumentocobrar-listado/:cliente', component: CoDocumentoCobrarNuevolistadoComponent },
            { path: 'codocumentocobrar-listado/:cliente/:accion/:filtro', component: CoDocumentoCobrarNuevolistadoComponent },
            { path: 'codocumentocobrar-listado/:accion/:bean', component: CoDocumentoCobrarNuevolistadoComponent },
            

            { path: 'cliente-listado', component: ClienteListadoComponent },
            { path: 'cliente-listado/:tipo', component: ClienteListadoComponent },   
            { path: 'cliente-listado/:tipo/:filtro', component: ClienteListadoComponent },            

            { path: 'cocotizacion-mantenimiento/:accion', component: CoCotizacionMantenimientoNuevoComponent },
            { path: 'cocotizacion-mantenimiento/:accion/:bean', component: CoCotizacionMantenimientoNuevoComponent },
            { path: 'cocotizacion-mantenimiento/:accion/:bean/:pantallaAccion', component: CoCotizacionMantenimientoNuevoComponent },
            { path: 'pedido-mantenimiento/:accion', component: PedidoMantenimientoNuevoComponent },
            { path: 'pedido-mantenimiento/:accion/:documento/:pantallaAccion', component: PedidoMantenimientoNuevoComponent },
            { path: 'pedido-mantenimiento/:accion/:bean', component: PedidoMantenimientoNuevoComponent },

            { path: 'letra-listado/:cliente', component: LetralistadoComponent },
            { path: 'linea-credito/:cliente', component: LineaCreditoComponent },

            { path: 'letra-listado/:cliente/:filtro', component: LetralistadoComponent },
            { path: 'linea-credito/:cliente/:filtro', component: LineaCreditoComponent },

            { path: 'linea-credito/:accion/:bean', component: LineaCreditoComponent },
            { path: 'generarpedido-listado', component: GenerarPedidoListadoComponent },
            { path: 'generarpedido-listado/:bean/:generar', component: GenerarPedidoListadoComponent },
            { path: 'cobranza-listado', component: CoCobranzaListado},

            { path: 'pedido_seguimiento', component: PedidosSeguimiento },
            { path: 'pedido_seguimiento/:documento', component: PedidosSeguimiento },
            { path: 'cotizacion-listado', component: CodCotizacionListado },
            { path: 'cotizacion-listado/:accion', component: CodCotizacionListado },


            { path: 'item-listado/:origen', component: WhItemMastComponent },
            { path: 'item-listado/:origen/:almacen', component: WhItemMastComponent },
            { path: 'item-listado/:origen/:almacen/:bean', component: WhItemMastComponent },
            {path:  'item-listado/:origen/:almacen/:bean/:accion', component: WhItemMastComponent },
            { path: 'item-listado/:origen/:almacen/:bean/:accion/:verdescuentos', component: WhItemMastComponent },
           
            { path: 'item-detalle/:origen', component: WhItemDetalleComponent },
            { path: 'item-detalle/:origen/:accion/:dto/:bean', component: WhItemDetalleComponent },
            { path: 'item-detalle/:origen/:accion/:dto/:bean/:verdescuentos', component: WhItemDetalleComponent },
            
            { path: 'item-inventario', component: WhItemInventarioComponent },
            { path: 'item-inventario/:origen/:codigo/:desc/:alma/:bean/:accion/:verdescuentos', component: WhItemInventarioComponent },
        ]
    }
];



export const AppRoutes: ModuleWithProviders = RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' });


